/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions
 */
export interface FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions
     */
    AllowOnlyNewEmail?: boolean | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions(value: object): value is FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions {
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'AllowOnlyNewEmail': json['AllowOnlyNewEmail'] == null ? undefined : json['AllowOnlyNewEmail'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsToJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptionsToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateWithExternalIdAdditionalOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AllowOnlyNewEmail': value['AllowOnlyNewEmail'],
    };
}

